import { IViewModel } from '../../interfaces/view-model.interface';

export class SimplifiedPermissionRequest {
    public constructor(public objectId: number, public memberType: string, public member: string) {
    }
}
